import { Dialog as DialogMui } from '@mui/material';
import { styled } from '@mui/material';

export const Dialog = styled(DialogMui)(() => ({
  '& .MuiDialog-paper': {
    borderRadius: 16,
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
}));

export const Actions = styled('div')`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
`;
